import theme from "@/theme";

export const styles = {
  walletBox: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "12px",
    padding: "24px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  walletInnerBox: {
    height: "304px",
    borderRadius: "10px",
    padding: "71px 20px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  currencyTabs: {
    width: "716px",
    height: "76px",
    display: "flex",
    gap: "16px",
    marginBottom: "40px",
  },

  currencyTab: (active: boolean) => ({
    width: "225.33px",
    padding: "8px 16px",
    borderRadius: "12px",
    border: active ? "none" : "1px solid #F4F5F6",
    backgroundColor: active ? theme.palette.custom.mainBlue : "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    color: active ? "#FFFFFF" : "#2A2D31",
    cursor: "pointer",
  }),

  currencyIcon: {
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "32px",
      height: "32px",
    },
  },

  currencyText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
  },

  centerBox: {
    height: "162px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // marginBottom: "40px",
  },

  satsIcon: {
    paddingBottom: "2px",
    width: "40px",
    height: "40px",
    display: "inline-block",
    "& svg": {
      width: "40px",
      height: "40px",
    },
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1300,
  },

  satsLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "-2%",
    margin: "2px 0 20px 0",
  },

  balanceTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#292929",
    marginBottom: "8px",
  },

  balanceAmount: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "34px",
    lineHeight: "32px",
    color: "#2A2D31",
    marginBottom: "8px",
  },

  balanceUsd: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "16px",
    color: theme.palette.custom.mainBlue,
  },

  actionButtons: {
    display: "flex",
    gap: "40px",
  },

  actionButton: {
    width: "338px",
    padding: "12px 16px",
    borderRadius: "12px",
    backgroundColor: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    textAlign: "center",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },

  receiveBtn: {
    width: "370px",
    height: "50px",
    border: `1px solid ${theme.palette.custom.mainBlue}`,
    color: theme.palette.custom.mainBlue,
    padding: "16px 40px",
    borderRadius: "12px",
    fontWeight: 500,
    cursor: "pointer",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: "24px",
  },

  sendBtn: {
    width: "370px",
    height: "50px",
    backgroundColor: theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    padding: "16px 40px",
    borderRadius: "12px",
    fontWeight: 500,
    cursor: "pointer",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: "24px",
  },

  sendReceiveBox: {
    width: "100%",
    display: "flex",
    gap: "16px",
    marginTop: "20px",
  },
};
